import { render, staticRenderFns } from "./list.vue?vue&type=template&id=7c1a1fcd&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1a1fcd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c1a1fcd')) {
      api.createRecord('7c1a1fcd', component.options)
    } else {
      api.reload('7c1a1fcd', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=7c1a1fcd&scoped=true", function () {
      api.rerender('7c1a1fcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/platformManagement/routeManagement/routeList/list.vue"
export default component.exports